import colonyAPI from '@/api/colony';
import * as types from './mutation-types';

export default {
  createSocialPost({ commit, dispatch }, payload) {
    commit(types.CREATE_SOCIAL_POST_REQUEST);

    return colonyAPI
      .post('radiodashboard/post-message/', payload)
      .then(response => commit(types.CREATE_SOCIAL_POST_SUCCESS, response))
      .catch(error => commit(types.CREATE_SOCIAL_POST_FAILURE, error.error));
  },

  updateScheduledPost({ commit }, payload) {
    commit(types.UPDATE_SCHEDULED_MESSAGE_REQUEST);

    return colonyAPI
      .patch(`radiodashboard/scheduled-messages/${payload.id}/`, payload)
      .then(() => commit(types.UPDATE_SCHEDULED_MESSAGE_SUCCESS, payload))
      .catch(error => commit(types.UPDATE_SCHEDULED_MESSAGE_FAILURE, error));
  },

  deleteScheduledPost({ commit }, id) {
    commit(types.DELETE_SCHEDULED_MESSAGE_REQUEST);

    return colonyAPI
      .delete(`radiodashboard/scheduled-messages/${id}/delete/`)
      .then(() => commit(types.DELETE_SCHEDULED_MESSAGE_SUCCESS, id))
      .catch(error => commit(types.DELETE_SCHEDULED_MESSAGE_FAILURE, error));
  },

  getScheduledMessages({ commit }) {
    commit(types.GET_SCHEDULED_MESSAGES_REQUEST);

    return colonyAPI
      .get('radiodashboard/scheduled-messages/')
      .then(response => commit(types.GET_SCHEDULED_MESSAGES_SUCCESS, response.data))
      .catch(error => commit(types.GET_SCHEDULED_MESSAGES_FAILURE, error.error));
  },

  editingPost({ commit }, post) {
    commit(types.EDITING_SOCIAL_POST, post);
  },

  creatingPost({ commit }, post) {
    commit(types.CREATING_SOCIAL_POST, post);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/social/actions.js